<template>
  <v-textarea
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.message, 'Mesaj')"
      v-model="text"
      :rules="textValidationRules"
      name="text"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-textarea>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type { TranslationList } from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const text = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      text.value = newValue;
    });

    watch(text, (newValue) => {
      const isValid = validateText(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-customer-status', { field: 'text', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const textValidationRules = [
      (v: string) => v.length >= 10 || translation(translationList.value.required, 'Acest câmp trebuie să conțină cel puțin 10 caractere'),
    ];

    function validateText(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = textValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return textValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateText(text.value);
      emit('validation-customer-status', { field: 'text', isValid });

      window.addEventListener('validate-customer', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'text') {
        const isValid = validateText(text.value, true);
        emit('validation-customer-status', { field: 'text', isValid });
      }
    };

    return {
      text,
      textValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>